/* eslint-disable react/prop-types */
import React from 'react'

import { IconProps } from '.'

const Girl: React.FC<IconProps> = ({ size = 40, ...rest }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      {...rest}
    >
      <circle cx="12" cy="12" r="12" fill="#FC5D9A"></circle>
      <path
        fill="#fff"
        d="M18.283 11.759c-.034 0-.068 0-.102.003-.346-1.394-1.099-2.652-2.14-3.57a6.132 6.132 0 00-3.726-1.544v-.532a2.062 2.062 0 001.617-.634 1.178 1.178 0 000-1.638 1.13 1.13 0 00-1.626 0c-.116.119-.218.25-.305.392a2.212 2.212 0 00-.308-.393 1.13 1.13 0 00-1.625 0 1.179 1.179 0 000 1.638 2.06 2.06 0 001.5.639c.041 0 .08 0 .117-.004v.533a6.143 6.143 0 00-3.726 1.543c-1.042.918-1.793 2.177-2.14 3.572a1.72 1.72 0 00-1.317.498 1.706 1.706 0 000 2.417c.323.32.76.5 1.215.5.027 0 .054 0 .081-.002a4.968 4.968 0 002.162 2.996c1.073.69 2.47 1.053 4.04 1.053 1.57 0 2.967-.364 4.04-1.053a4.987 4.987 0 002.162-2.998 1.72 1.72 0 001.295-.499 1.705 1.705 0 000-2.417c-.322-.32-.759-.5-1.214-.5zm-5.527-7.477a.5.5 0 01.724 0 .55.55 0 010 .763 1.446 1.446 0 01-1.165.446 1.834 1.834 0 01-.004-.077v-.09c.01-.392.168-.764.445-1.042zm-2.238.762a.55.55 0 010-.763.501.501 0 01.724 0c.276.278.435.65.444 1.042v.09c0 .027-.002.053-.004.078a1.45 1.45 0 01-1.164-.447z"
      ></path>
      <path
        fill="#FC5D9A"
        d="M9.586 13.68a.819.819 0 000-1.161.828.828 0 00-1.167 0 .819.819 0 000 1.162c.323.32.845.32 1.167 0zM15.267 13.894a.821.821 0 10-.41-1.592.821.821 0 10.41 1.592zM13.704 14.242a.32.32 0 00-.282.045.314.314 0 00-.114.159c-.002.007-.248.733-1.274.733-1.027 0-1.272-.726-1.275-.733a.314.314 0 10-.598.19c.016.046.394 1.168 1.873 1.168s1.858-1.12 1.873-1.168a.313.313 0 00-.203-.394zM12.402 7.713a.315.315 0 00-.53.24.313.313 0 00.1.218c.253.248.466.533.632.845.316.61.298 1.118-.056 1.551-.403.493-.865.449-1.104.378-.33-.096-.598-.351-.625-.595-.03-.263.058-.585.318-.71.165-.077.337-.039.486.11a.315.315 0 00.538-.22.313.313 0 00-.092-.222c-.336-.337-.797-.426-1.204-.232-.473.226-.737.752-.671 1.343.055.494.495.957 1.072 1.128.151.045.308.067.465.068.491 0 .958-.228 1.305-.652.514-.63.558-1.402.127-2.234a4.11 4.11 0 00-.761-1.016z"
      ></path>
    </svg>
  )
}

export default Girl
